import React from 'react';
import PropTypes from 'prop-types';

const TextTime = ({ value, className }) => {
  let timestring = "";
  if ((value) && (value !== null) && (typeof value.getMonth === 'function')) {
    let hours = value.getHours().toString();
    if (value.getHours() < 10) {
      hours = "0" + value.getHours().toString();
    }
    let minutes = value.getMinutes().toString();
    if (value.getMinutes() < 10) {
      minutes = "0" + value.getMinutes().toString();
    }
    timestring =  hours +  ":" + minutes;
  }
  return (
    <span className={className}>{timestring}</span>
  );
};

TextTime.propTypes = {
  value: PropTypes.object,
  className : PropTypes.string,
};

export default TextTime;